import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, CheckCircle2, ArrowLeft, ChevronLeft } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      // Public endpoint accepts { email } only.
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-cream flex items-center justify-center px-6 relative">
      <Link to="/" data-testid="back-to-home" className="absolute top-6 left-6 flex items-center gap-1 text-xs uppercase tracking-[0.15em] text-cream/50 hover:text-cream transition-colors">
        <ChevronLeft className="h-4 w-4" /> Accueil
      </Link>
      <div className="w-full max-w-md">
        <Link to="/" aria-label="Déstockage Luminaires — accueil" className="flex justify-center"><Logo to={null} size="lg" variant="dark" testId="forgot-logo" /></Link>
        <p className="text-[10px] uppercase tracking-[0.25em] text-cream/40 mt-1 text-center mb-10">Mot de passe oublié</p>

        {done ? (
          <div data-testid="forgot-done" className="text-center space-y-4">
            <CheckCircle2 className="h-12 w-12 text-gold mx-auto" strokeWidth={1.2} />
            <p className="text-cream/80">Si un compte existe pour <span className="text-cream">{email}</span>, un email contenant les instructions vient d&apos;être envoyé.</p>
            <p className="text-cream/50 text-xs">Le lien est valable 2 heures. Pensez à vérifier vos indésirables.</p>
            <Link to="/connexion" className="inline-flex items-center gap-2 mt-4 bg-gold text-ink px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-cream transition-colors">
              <ArrowLeft className="h-4 w-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form" className="space-y-5">
            <p className="text-cream/70 text-sm text-center">Saisissez votre adresse email. Vous recevrez un lien pour réinitialiser votre mot de passe.</p>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-cream/50">Email</label>
              <div className="relative mt-2">
                <Mail className="h-4 w-4 text-cream/30 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full h-12 pl-9 rounded-sm bg-white/5 border border-white/10 text-cream placeholder:text-cream/30 focus:outline-none focus:border-gold"
                  placeholder="vous@email.com"
                />
              </div>
            </div>
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-gold text-ink py-4 uppercase tracking-[0.15em] text-xs hover:bg-cream transition-colors disabled:opacity-60">
              {loading ? "Envoi..." : "Envoyer le lien"}
            </button>
            <p className="text-center text-cream/50 text-sm">
              <Link to="/connexion" data-testid="back-to-login" className="hover:text-cream underline underline-offset-2">Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
